package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class ProductSetsModel(
    @SerialName("data")
    val `data`: Data?=null,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)